import React from "react";
import { connect } from "react-redux";
import { RootState } from "../../redux";
import { IOperation } from "../../redux/modules/operations";
import { IReport, getReports } from "../../redux/modules/reports";
import { Link } from "react-router-dom";
import { formatPrice, formatDate } from "../../utils";
import "./report-list.css";

type ReportListProps = {
  getReports?: (s1: string, s2: string) => void;
  reports?: IReport;
};

type ReportListState = {
  startDate: string;
  endDate: string;
};

class ReportList extends React.Component<ReportListProps, ReportListState> {
  constructor(props: ReportListProps) {
    super(props);

    const startDate = new Date();
    const endDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    this.state = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    };
  }

  handleStartDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ startDate: event.target.value });
  };

  handleEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ endDate: event.target.value });
  };

  save = () => {
    this.props.getReports && this.props.getReports(this.state.startDate, this.state.endDate);
  };

  renderVisits = () => {
    if (!this.props.reports || !this.props.reports.visits) {
      return null;
    }
    const visits = this.props.reports.visits
      .sort((v1, v2) => {
        return new Date(v2.date).getTime() - new Date(v1.date).getTime();
      })
      .map((visit) => {
        const price = visit.services.map((serviceDto) => serviceDto.service.price).reduce((s1, s2) => s1 + s2, 0);
        return (
          <div className="report-list__item report-list__item--visit" key={visit.id}>
            <div className="report-list__item-content">
              <div className="report-list__item-date">
                <span className="report-list__item-icon">📅</span>
                {formatDate(visit?.date)}
              </div>
              <div className="report-list__item-client">
                <span className="report-list__item-label">Клієнт:</span>
                <Link to={`/client/${visit.clientId}`} className="report-list__item-link">{visit.client.name}</Link>
              </div>
              <div className="report-list__item-visit">
                <span className="report-list__item-label">Візит:</span>
                <Link to={`/visit/${visit.id}`} className="report-list__item-link">{visit.title}</Link>
              </div>
              <div className="report-list__item-price">
                <span className="report-list__item-label">Вартість:</span>
                <span className="report-list__item-value">{formatPrice(price)} грн</span>
              </div>
            </div>
          </div>
        );
      });

    return <div className="report-list__items">{visits}</div>;
  };

  renderSupplyOperations = () => {
    if (!this.props.reports || !this.props.reports.supplyOperations) {
      return null;
    }
    const operations = this.props.reports.supplyOperations
      .sort((o1, o2) => (new Date(o1.date) < new Date(o2.date) ? -1 : 1))
      .map((operation: IOperation) => {
        if (!operation?.product?.basePrice) {
          return null;
        }
        return (
          <div className="report-list__item report-list__item--supply" key={operation.id}>
            <div className="report-list__item-content">
              <div className="report-list__item-date">
                <span className="report-list__item-icon">📅</span>
                {formatDate(operation.date)}
              </div>
              <div className="report-list__item-product">
                <span className="report-list__item-label">Товар:</span>
                <Link to={`/product/${operation.productId}`} className="report-list__item-link">{operation.product.name}</Link>
              </div>
              <div className="report-list__item-amount">
                <span className="report-list__item-label">Додано:</span>
                <span className="report-list__item-value">{operation.amount}</span>
              </div>
              <div className="report-list__item-price">
                <span className="report-list__item-label">Вартість:</span>
                <span className="report-list__item-value">{formatPrice(operation.amount * operation.product.basePrice)} грн</span>
              </div>
            </div>
          </div>
        );
      })
      .filter(Boolean);

    return <div className="report-list__items">{operations}</div>;
  };

  renderSellOperations = () => {
    if (!this.props.reports || !this.props.reports.sellOperations) {
      return null;
    }
    const operations = this.props.reports.sellOperations
      .sort((o1, o2) => (new Date(o1.date) < new Date(o2.date) ? -1 : 1))
      .map((operation: IOperation) => {
        if (!operation?.product?.basePrice || !operation.sellPrice) {
          return null;
        }
        return (
          <div className="report-list__item report-list__item--sell" key={operation.id}>
            <div className="report-list__item-content">
              <div className="report-list__item-date">
                <span className="report-list__item-icon">📅</span>
                {formatDate(operation.date)}
              </div>
              <div className="report-list__item-product">
                <span className="report-list__item-label">Товар:</span>
                <Link to={`/product/${operation.productId}`} className="report-list__item-link">{operation?.product?.name}</Link>
              </div>
              <div className="report-list__item-amount">
                <span className="report-list__item-label">Продано:</span>
                <span className="report-list__item-value">{operation.amount}</span>
              </div>
              <div className="report-list__item-price">
                <span className="report-list__item-label">Прибуток:</span>
                <span className="report-list__item-value report-list__item-value--profit">{formatPrice((operation.sellPrice - operation?.product?.basePrice) * operation.amount)} грн</span>
              </div>
            </div>
          </div>
        );
      })
      .filter(Boolean);

    return <div className="report-list__items">{operations}</div>;
  };

  renderUseOperations = () => {
    if (!this.props.reports || !this.props.reports.useOperations) {
      return null;
    }
    const operations = this.props.reports.useOperations
      .sort((o1, o2) => (new Date(o1.date) < new Date(o2.date) ? -1 : 1))
      .map((operation: IOperation) => {
        if (!operation?.product?.basePrice) {
          return null;
        }
        return (
          <div className="report-list__item report-list__item--use" key={operation.id}>
            <div className="report-list__item-content">
              <div className="report-list__item-date">
                <span className="report-list__item-icon">📅</span>
                {formatDate(operation.date)}
              </div>
              <div className="report-list__item-product">
                <span className="report-list__item-label">Товар:</span>
                <Link to={`/product/${operation.productId}`} className="report-list__item-link">{operation.product.name}</Link>
              </div>
              <div className="report-list__item-amount">
                <span className="report-list__item-label">Списано:</span>
                <span className="report-list__item-value">{operation.amount}</span>
              </div>
              <div className="report-list__item-price">
                <span className="report-list__item-label">Собівартість:</span>
                <span className="report-list__item-value">{formatPrice(operation?.product?.basePrice * operation.amount)} грн</span>
              </div>
            </div>
          </div>
        );
      })
      .filter(Boolean);

    return <div className="report-list__items">{operations}</div>;
  };

  renderData = () => {
    if (!this.props.reports || this.props.reports.spentOnSupplies === undefined) {
      return null;
    }
    return (
      <div className="report-list__sections">
        <div className="report-list__section">
          <div className="report-list__section-header report-list__section-header--supply">
            <span className="report-list__section-icon">📥</span>
            <h3 className="report-list__section-title">Операції поповнення</h3>
          </div>
          <div className="report-list__section-content">
            {this.renderSupplyOperations()}
            <div className="report-list__summary">
              <p className="report-list__summary-text">
                <span className="report-list__summary-label">Загальна сума витрат:</span>{" "}
                <span className="report-list__summary-value">{formatPrice(this.props.reports?.spentOnSupplies)} грн</span>
              </p>
            </div>
          </div>
        </div>

        <div className="report-list__section">
          <div className="report-list__section-header report-list__section-header--sell">
            <span className="report-list__section-icon">💰</span>
            <h3 className="report-list__section-title">Операції Продажу</h3>
          </div>
          <div className="report-list__section-content">
            {this.renderSellOperations()}
            <div className="report-list__summary">
              <p className="report-list__summary-text">
                <span className="report-list__summary-label">Загальна сума заробітку від продажу:</span>{" "}
                <span className="report-list__summary-value report-list__summary-value--profit">{formatPrice(this.props.reports?.earnedOnProducts || 0)} грн</span>
              </p>
              <p className="report-list__summary-text">
                <span className="report-list__summary-label">Загальна сума повернена в касу від продажу:</span>{" "}
                <span className="report-list__summary-value">{formatPrice(this.props.reports?.retunedMoneyOnProducts || 0)} грн</span>
              </p>
            </div>
          </div>
        </div>

        <div className="report-list__section">
          <div className="report-list__section-header report-list__section-header--use">
            <span className="report-list__section-icon">📤</span>
            <h3 className="report-list__section-title">Операції Списання</h3>
          </div>
          <div className="report-list__section-content">
            {this.renderUseOperations()}
            <div className="report-list__summary">
              <p className="report-list__summary-text">
                <span className="report-list__summary-label">Загальна вартість списаного товару:</span>{" "}
                <span className="report-list__summary-value">{formatPrice(this.props.reports?.spentOnUseOperations || 0)} грн</span>
              </p>
            </div>
          </div>
        </div>

        <div className="report-list__section">
          <div className="report-list__section-header report-list__section-header--visit">
            <span className="report-list__section-icon">📋</span>
            <h3 className="report-list__section-title">Візити</h3>
          </div>
          <div className="report-list__section-content">
            {this.renderVisits()}
            <div className="report-list__summary">
              <p className="report-list__summary-text">
                <span className="report-list__summary-label">Загальна сума заробітку від візитів:</span>{" "}
                <span className="report-list__summary-value report-list__summary-value--profit">{formatPrice(this.props.reports?.earnedOnVisits || 0)} грн</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="report-list">
        <form onSubmit={(e) => e.preventDefault()} className="report-list__form">
          <div className="report-list__form-container">
            <div className="report-list__form-group">
              <label htmlFor="reportListStartDate" className="report-list__label">Від</label>
              <input
                type="date"
                className="report-list__input"
                onChange={(event) => this.handleStartDate(event)}
                id="reportListStartDate"
                value={this.state.startDate ? formatDate(this.state.startDate) : ""}
                required
              />
            </div>
            <div className="report-list__form-group">
              <label htmlFor="reportListEndDate" className="report-list__label">До</label>
              <input
                type="date"
                className="report-list__input"
                onChange={(event) => this.handleEndDate(event)}
                id="reportListEndDate"
                value={this.state.endDate ? formatDate(this.state.endDate) : ""}
                required
              />
            </div>
            <button type="button" className="report-list__btn-search" onClick={this.save}>
              <span className="report-list__btn-icon">🔍</span>
              Пошук
            </button>
          </div>
        </form>
        {this.renderData()}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return { reports: state.reports };
};

export default connect(mapStateToProps, { getReports })(ReportList);
